import { render, staticRenderFns } from "./consultHorario.vue?vue&type=template&id=0bbeb296&"
import script from "./consultHorario.vue?vue&type=script&lang=js&"
export * from "./consultHorario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports